export const translations = {
  en: {
    // Navbar
    nav: {
      home: 'Home',
      tours: 'Tours',
      about: 'About',
      reviews: 'Reviews',
      blog: 'Blog',
      contact: 'Contact',
      bookNow: 'Book Now'
    },
    // Hero
    hero: {
      badge: '20+ Years of Trusted Service',
      title1: 'Los Sueños',
      title2: 'Luxury Transportation',
      subtitle: 'Premium transportation and unforgettable tours with Costa Rica\'s most experienced local guides. From airport transfers to adventure tours.',
      cta: 'Book Your Transfer',
      ctaSecondary: 'Explore Tours',
      trustedBy: 'Trusted by travelers worldwide',
      safeReliable: 'Safe & Reliable',
      available247: '24/7 Available',
      localExperts: 'Local Experts'
    },
    // Tours Section / Tours Page
    tours: {
      title: 'Our Tours & Services',
      subtitle: 'Choose from our selection of premium transportation and adventure tours',
      featuredTitle: 'Featured Tours',
      featuredSubtitle: 'Our most popular experiences',
      all: 'All Services',
      transfers: 'Transfers',
      atvBuggy: 'ATV & Buggy',
      zipline: 'Ziplining',
      horseback: 'Horseback Riding',
      rafting: 'Rafting',
      hiking: 'Hiking',
      combos: 'Combos',
      fromPrice: 'From',
      bookNow: 'Book Now',
      viewAll: 'View All Tours',
      passengers: 'passengers',
      perPerson: '/person',
      upTo: 'up to',
      pax: 'pax',
      pageTitle: 'Tours & Adventures',
      pageSubtitle: 'Experience Costa Rica with Travel Guide Costa Rica - Transportation, ATV adventures, ziplining, horseback riding and more. All tours include transportation from Los Sueños.',
      transportIncluded: 'Transport from Los Sueños included',
      fruitsHydration: 'Fresh fruits & hydration',
      lunchOption: 'Lunch option +$10 (Free on Full Day Combos)',
      noToursFound: 'No tours found',
      tryDifferent: 'Try selecting a different category',
      perPersonLabel: '/ person',
      per2People: '/ 2 people',
      perUpTo5Pax: '/ up to 5 pax',
      transportPlusTours: 'transport (5 pax) + tours',
      transportPlusTour: 'transport (5 pax) + tour',
      lunchIncluded: 'LUNCH INCLUDED',
      onePerson: '1 person',
      twoPeople: '2 people',
      upToLabel: 'Up to',
      requirementsTitle: 'Requirements & Policies',
      atvTitle: 'ATV & Buggy',
      atvReq1: 'Valid driver\'s license (A1 or B1) required',
      atvReq2: 'Max weight: 120kg (single), 200kg (buggy)',
      atvReq3: 'Security deposit required (refundable)',
      atvReq4: '24-hour cancellation: 100% refund',
      ziplineTitle: 'Ziplining',
      ziplineReq1: 'Max weight: 120kg (265 lbs)',
      ziplineReq2: 'Max waist: 99cm (39 in)',
      ziplineReq3: 'Children 4+ years welcome',
      ziplineReq4: 'Cancellations: Reschedule only',
      horsebackTitle: 'Horseback Riding',
      horsebackReq1: 'Max weight: 100kg (220 lbs)',
      horsebackReq2: 'Suitable for beginners',
      horsebackReq3: 'Well-trained gentle horses',
      horsebackReq4: '24-hour cancellation: 100% refund',
      generalTitle: 'General Info',
      genReq1: 'Transport from Los Sueños included',
      genReq2: 'Certified guides on all tours',
      genReq3: 'Add lunch: +$10 per person',
      genReq4: 'Full Day Combos include lunch FREE',
      customCtaTitle: 'Need a Custom Tour Package?',
      customCtaSubtitle: 'Can\'t find what you\'re looking for? Contact us for a personalized tour package tailored to your needs.',
      customCtaButton: 'Contact Us on WhatsApp'
    },
    // Booking
    booking: {
      title: 'Book Your Experience',
      backToTours: 'Back to Tours',
      step1: 'Details',
      step2: 'Payment',
      step3: 'Confirmation',
      bookingDetails: 'Booking Details',
      fullName: 'Full Name',
      fullNamePlaceholder: 'John Doe',
      email: 'Email Address',
      emailPlaceholder: 'john@example.com',
      phone: 'Phone Number',
      phonePlaceholder: '+1 234 567 8900',
      date: 'Travel Date',
      passengers: 'Number of Passengers',
      passenger: 'passenger',
      passengersPlural: 'passengers',
      notes: 'Special Requests (Optional)',
      notesPlaceholder: 'Any special requests or requirements... (e.g., flight number, hotel pickup)',
      continuePayment: 'Continue to Payment',
      processing: 'Processing...',
      basePrice: 'Base price (up to 5 pax)',
      extraPax: 'Extra pax',
      addOns: 'Add-ons',
      subtotal: 'Subtotal',
      vat: 'VAT (13%)',
      total: 'Total',
      vatIncluded: 'VAT included',
      optionalAddOns: 'Optional Add-ons',
      howMany: 'How many?',
      included: 'included',
      extraPerPax: 'extra/passenger',
      flatRate: 'Flat rate for 1-5 passengers',
      upToIncluded: 'Up to 5 passengers included.',
      perExtra: '/extra passenger',
      pricePerPerson: 'Price per person',
      perPersonNote: 'per person',
      payWithStripe: 'Pay with Card',
      stripeDesc: 'Visa, Mastercard, American Express',
      payWithPaypal: 'Pay with PayPal',
      paypalDesc: 'Direct payment via PayPal.me',
      perPerson: '/person',
      securePayment: 'Secure Payment:',
      secureDesc: 'Your payment information is encrypted and secure. We never store your card details.',
      back: 'Back',
      backToDetails: 'Back to Details',
      bookingCreated: 'Booking created! Please complete payment.',
      bookingFailed: 'Failed to create booking. Please try again.',
      tourNotFound: 'Tour not found',
      paymentFailed: 'Payment failed. Please try again.',
      selectPaymentMethod: 'Select Payment Method',
      paymentSubtitle: 'Choose your preferred payment method to complete your booking.',
      max: 'Max',
      paxRange: '1-5 pax',
      paxLabel: 'Passengers',
      extraPaxFee: '/person',
      nationalParkFees: 'National Park fees',
      bookOnline: 'Book online',
      addOnsTotal: 'Add-ons total:',
      paypalRedirect: 'Redirecting to PayPal. After payment, please send confirmation email.'
    },
    // Reviews
    reviews: {
      title: 'What Our Guests Say',
      subtitle: 'Read reviews from travelers who experienced our services',
      viewAll: 'View All Reviews on TripAdvisor',
      rating: 'Rating',
      reviews: 'reviews'
    },
    // About
    about: {
      title: 'About Travel Guide Costa Rica',
      subtitle: 'Why Choose Us?',
      description: 'With over 20 years of experience, we provide safe, reliable, and memorable transportation and tour services throughout Costa Rica.',
      experience: 'Years Experience',
      customers: 'Happy Customers',
      toursCompleted: 'Tours Completed',
      rating: 'Star Rating',
      whyUs1Title: 'Professional Drivers',
      whyUs1Desc: 'Experienced, bilingual drivers who know every route',
      whyUs2Title: 'Premium Vehicles',
      whyUs2Desc: 'Modern, air-conditioned vehicles for your comfort',
      whyUs3Title: 'Best Prices',
      whyUs3Desc: 'Competitive rates with no hidden fees',
      whyUs4Title: '24/7 Support',
      whyUs4Desc: 'Always available to assist you'
    },
    // Contact
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      whatsapp: 'WhatsApp',
      email: 'Email',
      phone: 'Phone',
      location: 'Location',
      sendMessage: 'Send Message',
      sending: 'Sending...',
      name: 'Your Name',
      yourEmail: 'Your Email',
      yourPhone: 'Your Phone',
      message: 'Message',
      messagePlaceholder: 'How can we help you?',
      successMessage: 'Message sent successfully! We\'ll contact you soon.',
      errorMessage: 'Failed to send message. Please try WhatsApp.',
      quickContact: 'Quick Contact',
      responseTime: 'We typically respond within 1 hour'
    },
    // Footer
    footer: {
      description: 'Your trusted transportation and tour partner in Costa Rica for over 20 years.',
      quickLinks: 'Quick Links',
      contactUs: 'Contact Us',
      followUs: 'Follow Us',
      services: 'Services',
      legal: 'Legal',
      privacy: 'Privacy Policy',
      terms: 'Terms of Service',
      cancellation: 'Cancellation Policy',
      environmental: 'Environmental Policy',
      safety: 'Safety Information',
      community: 'Local Community Support',
      allRights: 'All rights reserved.',
      airportTransfers: 'Airport Transfers',
      privateTours: 'Private Tours',
      adventureTours: 'Adventure Tours',
      home: 'Home',
      toursTransfers: 'Tours & Transfers',
      aboutUs: 'About Us',
      reviews: 'Reviews',
      contact: 'Contact',
      excellence: '20+ years of excellence in Costa Rican tourism',
      location: 'San Pedro de Poas, Costa Rica'
    },
    // Success Page
    success: {
      title: 'Booking Confirmed!',
      subtitle: 'Thank you for booking with Travel Guide Costa Rica. We can\'t wait to show you the beauty of Costa Rica!',
      bookingReference: 'Booking Reference',
      confirmed: 'Confirmed',
      bookedOn: 'Booked on:',
      contactInformation: 'Contact Information',
      totalPaid: 'Total Paid',
      whatNext: 'What\'s Next?',
      step1: 'You\'ll receive a confirmation email with all the details.',
      step2: 'Our team will contact you 24 hours before your scheduled date.',
      step3: 'For any questions, contact us via WhatsApp at +506 8817-3167.',
      checkEmail: 'Check Your Email',
      emailFrom: 'Your confirmation will be sent from',
      checkSpam: 'If you don\'t see it in your inbox, please check your',
      spamFolder: 'Spam',
      or: 'or',
      junkFolder: 'Junk',
      markNotSpam: 'folder and mark us as "Not Spam" to receive future communications.',
      browseMore: 'Browse More Tours',
      contactWhatsapp: 'Contact via WhatsApp',
      verifying: 'Verifying your payment...',
      pleaseWait: 'Please wait while we confirm your booking.',
      paymentIssue: 'Payment Issue',
      browseTours: 'Browse Tours',
      contactSupport: 'Contact Support',
      missingInfo: 'Missing payment information',
      timedOut: 'Payment status check timed out. Please contact support.',
      sessionExpired: 'Payment session expired. Please try again.',
      failedVerify: 'Failed to verify payment. Please contact support.',
      passenger: 'passenger',
      passengersPlural: 'passengers'
    },
    // Cancellation Policy
    cancellation: {
      title: 'Cancellation Policy',
      subtitle: 'Please read our cancellation policy carefully before making a reservation.',
      importantNotice: 'Important Notice',
      importantNoticeText: 'By completing your booking, you acknowledge that you have read, understood, and agree to our cancellation policy and pickup information requirements.',
      pickupTitle: 'Pickup & Destination Information Requirements',
      pickupDesc: 'To ensure a smooth and timely service, please provide accurate and complete information when making your reservation.',
      forTransfers: 'For Airport Transfers',
      transfersDesc: 'Airport Transfer, Luxury Transportation & Arenal Transfer',
      coverageArea: 'Service Coverage Area',
      airportZone: 'Airport Zone:',
      airportZoneDesc: 'Within 5 miles of Juan Santamaría International Airport (SJO)',
      losSuenosResort: 'Los Sueños Resort:',
      losSuenosDesc: 'Any hotel, condominium, or private property within Los Sueños Marriott Resort & Marina',
      arriving: 'Arriving in Costa Rica',
      arrivingSubtitle: 'SJO Airport (within 5 miles) → Los Sueños Resort',
      arrivalFlight: 'Arrival flight number',
      arrivalDate: 'Arrival date and time',
      airline: 'Airline name',
      destAddress: 'Exact destination address/hotel',
      numPassengers: 'Number of passengers',
      contactPhone: 'Contact phone number',
      departing: 'Departing from Costa Rica',
      departingSubtitle: 'Los Sueños Resort → SJO Airport (within 5 miles)',
      departureFlight: 'Departure flight number',
      departureDate: 'Departure date and time',
      pickupAddress: 'Exact pickup address/hotel',
      forTours: 'For Tours & Adventures',
      toursDesc: 'ATV, Zipline, Horseback Riding, Combos & Other Tours',
      requiredPickup: 'Required Pickup Information',
      pickupInfoDesc: 'Please provide your exact pickup location so our team can arrive on time:',
      hotelName: 'Hotel name or property address',
      pickupTime: 'Pickup Time',
      pickupTimeDesc: 'Our team will confirm your exact pickup time based on your tour schedule. Pickup is typically 30 minutes before your tour start time.',
      disclaimer: 'Important Disclaimer',
      disclaimerText: 'Travel Guide Costa Rica is not responsible for any issues, delays, or missed services resulting from incorrect, incomplete, or unclear information provided by the customer. This includes but is not limited to:',
      disclaimer1: 'Wrong pickup or destination addresses',
      disclaimer2: 'Incorrect flight numbers or times',
      disclaimer3: 'Failure to provide contact information',
      disclaimer4: 'Miscommunication regarding pickup locations',
      disclaimerEnd: 'Please double-check all details before confirming your reservation.',
      customerCancel: 'Customer Cancellation',
      lessThan24h: 'Less than 24 hours before scheduled service',
      lessThan24hDesc: 'No refund. Cancellations made less than 24 hours before your scheduled tour or transfer are not eligible for a refund.',
      moreThan24h: 'More than 24 hours before scheduled service',
      moreThan24hDesc: 'Full refund available. Cancellations made more than 24 hours in advance are eligible for a complete refund.',
      noShow: 'No-Show Policy',
      noShowTitle: 'Failure to appear at scheduled pickup',
      noShowDesc: 'If you fail to appear at the designated pickup location at the scheduled time without prior notice, no refund will be provided and the full amount will be charged.',
      weather: 'Weather-Related Cancellations',
      weatherDesc: 'Your safety is our priority. In cases of severe weather conditions that make it unsafe to proceed with the scheduled service:',
      fullRefund100: '100% Full Refund',
      fullRefund100Desc: 'If your tour or transfer is cancelled due to bad weather conditions (heavy rain, storms, flooding, or other unsafe conditions), you will receive a full refund of 100% of your payment.',
      weatherNote: '* Weather cancellations are determined by Travel Guide Costa Rica based on safety assessments. You may also choose to reschedule at no additional cost.',
      companyCancel: 'Cancellation by Travel Guide Costa Rica',
      companyCancelDesc: 'In the rare event that we must cancel your service due to unforeseen circumstances (severe weather conditions, natural disasters, vehicle emergencies, or other factors beyond our control), you will be offered:',
      fullRefund: 'Full Refund',
      fullRefundDesc: '100% of your payment returned within 5-7 business days',
      rescheduling: 'Rescheduling',
      reschedulingDesc: 'Reschedule your service at no additional cost',
      howToCancel: 'How to Request a Cancellation',
      howToCancelDesc: 'All cancellation requests must be submitted via email to:',
      includeBooking: 'Please include your booking confirmation number and the reason for cancellation.',
      refundTime: 'Refund Processing Time',
      businessDays: '5-7 Business Days',
      businessDaysDesc: 'Approved refunds will be processed within 5-7 business days. The refund will be credited to the original payment method used during booking.',
      questions: 'Have Questions?',
      questionsDesc: 'If you have any questions about our cancellation policy, please don\'t hesitate to contact us.',
      emailUs: 'Email Us',
      whatsapp: 'WhatsApp',
      lastUpdated: 'Last updated: March 2026'
    },
    // Blog
    blog: {
      title: 'Travel Blog',
      subtitle: 'Tips, guides, and insights about Costa Rica transportation and adventures',
      loading: 'Loading blog posts...'
    },
    // Local Community Support (dedicated page)
    community: {
      title: 'Local Community Support',
      subtitle: 'Travel Guide Costa Rica believes in tourism that uplifts the people and places where we operate.',
      p1: 'Travel Guide Costa Rica promotes responsible tourism by supporting local businesses, guides, and providers in the communities where it operates.',
      p2: 'We also encourage travelers to respect local customs, consume national products, and contribute positively to the sustainable development of the communities visited.',
      p3: 'Our company fosters environmental education practices and ecological awareness during all tourism and transportation services.',
      closingTitle: 'Travel with Purpose',
      closingText: 'Every tour you book helps strengthen local families and protect Costa Rica\'s heritage. Thank you for being part of this journey.',
      lastUpdated: 'Last updated: May 2026'
    },
    // Safety Information (ICT compliance)
    safety: {
      title: 'Safety Information',
      subtitle: 'Your safety is our top priority. Please read these recommendations before and during your tours.',
      intro: 'Travel Guide Costa Rica is committed to providing safe, reliable, and enjoyable experiences. This page outlines essential safety guidelines for all travelers — required for compliance with the Costa Rican Tourism Institute (ICT).',
      generalTitle: 'General Tourist Safety',
      generalIntro: 'To ensure a safe experience throughout Costa Rica:',
      gen1: 'Always carry a copy of your passport or official ID.',
      gen2: 'Inform a trusted person of your daily itinerary.',
      gen3: 'Keep valuables (passport, electronics, jewelry) in your hotel safe when possible.',
      gen4: 'Use only official, authorized transportation services like Travel Guide Costa Rica.',
      gen5: 'Trust your instincts — if a place or situation feels unsafe, leave immediately.',
      seatbeltsTitle: 'Seat Belts & Vehicle Safety',
      seatbeltsHighlight: '⚠️ Wearing a seat belt is mandatory in Costa Rica — for ALL passengers in ALL seats.',
      belt1: 'Fasten your seat belt as soon as you sit down, and keep it fastened until the vehicle stops.',
      belt2: 'Children under 12 must travel in the back seat with appropriate restraint systems.',
      belt3: 'Children under 4 years old or under 1.45m (4 ft 9 in) must use a child safety seat.',
      belt4: 'Do not distract the driver during the trip; help is just a request away.',
      belt5: 'Travel Guide vehicles are regularly inspected and meet RITEVE technical standards.',
      recommendationsTitle: 'Recommendations',
      beforeTitle: 'Before the Tour',
      before1: 'Hydrate, sleep well, and eat lightly before adventure tours.',
      before2: 'Wear comfortable clothing and closed-toe shoes for outdoor activities.',
      before3: 'Bring sunscreen, sunglasses, hat, insect repellent and a refillable water bottle.',
      before4: 'Notify our team of any medical condition, allergy, or medication you take.',
      duringTitle: 'During the Tour',
      during1: 'Always follow the instructions of your guide and driver.',
      during2: 'Stay with your group; do not wander off authorized paths.',
      during3: 'Keep cash, documents, and electronics in a secure pocket or bag.',
      during4: 'Communicate any discomfort or health issue to the guide immediately.',
      during5: 'Do not consume alcohol or substances before or during active tours.',
      healthTitle: 'Health Recommendations',
      health1: 'Costa Rica\'s tropical climate can cause heat exhaustion — drink water frequently.',
      health2: 'Use biodegradable sunscreen to protect both your skin and the environment.',
      health3: 'If you experience dizziness, nausea, or unusual fatigue, stop the activity and inform your guide.',
      health4: 'Travel insurance is highly recommended for international visitors.',
      conductTitle: 'Code of Conduct',
      conductIntro: 'Costa Rica is known for its "Pura Vida" — please help us preserve that spirit:',
      doTitle: 'Please DO',
      do1: 'Respect local communities, customs, and Indigenous peoples.',
      do2: 'Be patient and friendly — "Pura Vida" is a way of life here.',
      do3: 'Support local businesses, artisans, and family-run establishments.',
      do4: 'Report any unsafe situation immediately to the guide or authorities.',
      dontTitle: 'Please DO NOT',
      dont1: 'Do not feed, touch, or chase wildlife.',
      dont2: 'Do not collect plants, shells, rocks or any natural element.',
      dont3: 'Do not engage in illegal activities or consume illegal substances.',
      dont4: 'Do not exploit children for tourism (a crime in Costa Rica — Law 7899).',
      dont5: 'Do not enter private property or restricted areas without permission.',
      emergencyTitle: 'Emergencies',
      emergencyNumber: 'National Emergency Number',
      emergencyNumberHint: 'Free 24/7 from any phone in Costa Rica',
      duringEmergencyTitle: 'In Case of an Emergency',
      emg1: 'Stay calm. Call 911 immediately and clearly state your location.',
      emg2: 'If injured, do not move unnecessarily — wait for professional help.',
      emg3: 'Follow the guide\'s evacuation or first-aid instructions.',
      emg4: 'Notify the embassy of your country if you are a foreign visitor.',
      emg5: 'Travel Guide will assist with logistics, transport to the nearest medical center, and communication.',
      numbersTitle: 'Important Numbers',
      policeLabel: 'Emergency (Police, Fire, Medical)',
      trafficLabel: 'Traffic Police (Tránsito)',
      redCrossLabel: 'Red Cross (Ambulance)',
      firefightersLabel: 'Firefighters',
      touristPoliceLabel: 'Tourist Police',
      tgcrLabel: 'Travel Guide CR — 24/7',
      insuranceTitle: 'Insurance & Vehicle Compliance',
      insuranceIntro: 'All Travel Guide Costa Rica vehicles operate with:',
      ins1: 'Mandatory liability insurance (SOA) and additional coverage for passengers.',
      ins2: 'RITEVE-certified technical inspection (vehicle safety standards).',
      ins3: 'Licensed and trained drivers with valid commercial credentials (CTP).',
      commitmentTitle: 'Our Safety Commitment',
      commitmentText: 'Travel Guide Costa Rica operates in compliance with the applicable regulations of the Costa Rican tourism sector and is committed to continuously strengthening its safety, quality, and sustainability standards.',
      lastUpdated: 'Last updated: May 2026'
    },
    // Environmental Policy
    environmental: {
      title: 'Environmental Policy for Travelers',
      subtitle: 'Travel Guide Costa Rica - Sustainable & responsible tourism',
      intro1: 'At Travel Guide Costa Rica we believe that traveling through Costa Rica should be an unforgettable experience and, at the same time, respectful of the environment.',
      intro2: 'As a pioneering country in environmental conservation and sustainable tourism, Costa Rica actively protects its forests, beaches, rivers, wildlife, and national parks. That is why we invite all our travelers to adopt responsible practices during our tours and transportation services.',
      commitmentTitle: 'Our Environmental Commitment',
      commitmentIntro: 'Travel Guide Costa Rica commits to:',
      commitment1: 'Promote sustainable and responsible tourism.',
      commitment2: 'Reduce the environmental impact of our operations.',
      commitment3: 'Foster good environmental practices among travelers and collaborators.',
      commitment4: 'Respect Costa Rica\'s environmental laws and regulations.',
      commitment5: 'Protect the country\'s biodiversity and natural resources.',
      wasteTitle: 'Waste Management Policy in Transportation',
      wasteIntro: 'To keep Costa Rica\'s roads, communities, and natural areas clean:',
      wasteUnits: 'In all our transportation units:',
      waste1: 'Each vehicle has an internal trash bin for waste disposal.',
      waste2: 'Passengers are asked not to throw trash out of windows or doors.',
      waste3: 'Waste will be collected and disposed of properly at the end of each service.',
      waste4: 'We promote the reduction of single-use plastics.',
      waste5: 'We recommend using reusable bottles and eco-friendly items.',
      wasteSeparation: 'Waste Separation',
      separationIntro: 'When possible, we encourage the separation of:',
      plastic: 'Plastic',
      aluminum: 'Aluminum',
      paper: 'Paper',
      organic: 'Organic',
      behaviorTitle: 'Responsible Behavior in Nature',
      behaviorIntro: 'Costa Rica is home to nearly 6% of the world\'s biodiversity. Help us protect it by following these recommendations:',
      wildlifeTitle: 'Respect for Wildlife',
      wildlife1: 'Do not feed wild animals.',
      wildlife2: 'Do not touch or chase animals.',
      wildlife3: 'Keep a safe distance from wildlife.',
      ecoTitle: 'Ecosystem Protection',
      eco1: 'Stay on authorized trails.',
      eco2: 'Do not remove plants, stones, shells, or natural elements.',
      eco3: 'Do not damage reefs, mangroves, or forests.',
      wasteRespTitle: 'Responsible Waste Management',
      wasteResp1: 'Always carry your trash until you find a proper container.',
      wasteResp2: 'Avoid leaving waste on beaches, rivers, or national parks.',
      pollutionTitle: 'Pollution Reduction',
      pollution1: 'Avoid excessive use of disposable plastics.',
      pollution2: 'Minimize noise in natural areas.',
      pollution3: 'Use biodegradable sunscreens and products when possible.',
      waterEnergyTitle: 'Responsible Use of Water and Energy',
      waterEnergyIntro: 'We invite our travelers to:',
      waterEnergy1: 'Use water consciously.',
      waterEnergy2: 'Turn off lights and air conditioning when not needed.',
      waterEnergy3: 'Support local businesses committed to sustainability.',
      complianceTitle: 'Compliance with Costa Rica\'s Environmental Regulations',
      complianceIntro: 'This policy is inspired by principles promoted by Costa Rica\'s environmental institutions and programs, including:',
      compliance1: 'National System of Conservation Areas (SINAC)',
      compliance2: 'Costa Rican Tourism Institute (ICT)',
      compliance3: 'Sustainable Tourism Program',
      compliance4: 'Current Costa Rican environmental legislation',
      educationTitle: 'Education and Environmental Awareness',
      educationIntro: 'Our goal is for every visitor to:',
      education1: 'Enjoy Costa Rica,',
      education2: 'Get to know its natural richness,',
      education3: 'And actively contribute to its conservation for future generations.',
      communityTitle: 'Local Community Support',
      community1: 'Travel Guide Costa Rica promotes responsible tourism by supporting local businesses, guides, and providers in the communities where it operates.',
      community2: 'We also encourage travelers to respect local customs, consume national products, and contribute positively to the sustainable development of the communities visited.',
      community3: 'Our company fosters environmental education practices and ecological awareness during all tourism and transportation services.',
      invitationTitle: 'An Invitation to Travelers',
      invitationQuote: 'Traveling responsibly means leaving only footprints and taking only memories.',
      invitationThanks: 'Thank you for helping us protect Costa Rica\'s nature.',
      lastUpdated: 'Last updated: May 2026'
    },
    // Survey
    survey: {
      title: 'How was your experience?',
      subtitle: 'Your feedback helps us improve. Takes 2 minutes.',
      hello: 'Hello',
      thanksFor: 'Thank you for choosing Travel Guide Costa Rica for your',
      overall: 'Overall, how would you rate your experience?',
      tapToRate: 'Tap the stars to rate',
      categoriesTitle: 'Rate each aspect (optional)',
      driver: 'Driver',
      vehicle: 'Vehicle',
      punctuality: 'Punctuality',
      tour: 'Tour / Service',
      npsQuestion: 'How likely are you to recommend us to a friend?',
      npsHint: '0 = Not at all · 10 = Extremely likely',
      recommendQuestion: 'Would you book with us again?',
      yes: 'Yes',
      no: 'No',
      commentLabel: 'Any comments or suggestions? (optional)',
      commentPlaceholder: 'Tell us what we did well or how we can improve...',
      submitBtn: 'Submit Feedback',
      submitting: 'Submitting...',
      ratingRequired: 'Please select a rating',
      thanks5Title: '🎉 Thank you so much!',
      thanks5Subtitle: 'We are thrilled you enjoyed it! Would you mind sharing your experience publicly? It really helps small businesses like ours.',
      shareTripadvisor: 'Share on TripAdvisor',
      shareGoogle: 'Share on Google',
      noThanks: 'Maybe later',
      thanksLowTitle: 'Thank you for your honest feedback',
      thanksLowSubtitle: 'We\'re sorry your experience wasn\'t perfect. Our team will reach out to you shortly to make it right.',
      backHome: 'Back to home',
      alreadySubmittedTitle: 'Survey already submitted',
      alreadySubmittedSubtitle: 'Thank you! We\'ve already received your feedback for this booking.',
      invalidTitle: 'Invalid or expired link',
      invalidSubtitle: 'Please use the link from your email. If you keep having trouble, contact us via WhatsApp.',
      loading: 'Loading...',
      q1: 'How would you rate the punctuality of the service?',
      q2: 'How would you rate the attention and friendliness of the driver or guide?',
      q3: 'How would you rate the cleanliness and comfort of the vehicle or service?',
      q4: 'Did you feel safe during the transfer or tour?',
      q5: 'Would you recommend Travel Guide Costa Rica to other travelers?',
      answerRequired: 'Please answer all questions before submitting.',
      opt: {
        excelente: 'Excellent', muy_buena: 'Very good', buena: 'Good', regular: 'Fair', deficiente: 'Poor',
        si_completamente: 'Yes, completely', si_mayoria: 'Yes, mostly', parcialmente: 'Partially', no: 'No',
        si_definitivamente: 'Yes, definitely', probablemente_si: 'Probably yes', no_seguro: 'Not sure', probablemente_no: 'Probably not'
      }
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'An error occurred',
      success: 'Success!',
      close: 'Close',
      back: 'Back',
      next: 'Next',
      submit: 'Submit',
      cancel: 'Cancel',
      learnMore: 'Learn More',
      seeAll: 'See All'
    }
  },
  es: {
    // Navbar
    nav: {
      home: 'Inicio',
      tours: 'Tours',
      about: 'Nosotros',
      reviews: 'Reseñas',
      blog: 'Blog',
      contact: 'Contacto',
      bookNow: 'Reservar'
    },
    // Hero
    hero: {
      badge: 'Más de 20 Años de Servicio Confiable',
      title1: 'Los Sueños',
      title2: 'Transporte de Lujo',
      subtitle: 'Transporte premium y tours inolvidables con los guías locales más experimentados de Costa Rica. Desde traslados al aeropuerto hasta tours de aventura.',
      cta: 'Reserva Tu Traslado',
      ctaSecondary: 'Explorar Tours',
      trustedBy: 'Confiado por viajeros de todo el mundo',
      safeReliable: 'Seguro y Confiable',
      available247: 'Disponible 24/7',
      localExperts: 'Expertos Locales'
    },
    // Tours Section / Tours Page
    tours: {
      title: 'Nuestros Tours y Servicios',
      subtitle: 'Elige entre nuestra selección de transporte premium y tours de aventura',
      featuredTitle: 'Tours Destacados',
      featuredSubtitle: 'Nuestras experiencias más populares',
      all: 'Todos los Servicios',
      transfers: 'Traslados',
      atvBuggy: 'ATV y Buggy',
      zipline: 'Canopy',
      horseback: 'Cabalgata',
      rafting: 'Rafting',
      hiking: 'Hiking',
      combos: 'Combos',
      fromPrice: 'Desde',
      bookNow: 'Reservar',
      viewAll: 'Ver Todos los Tours',
      passengers: 'pasajeros',
      perPerson: '/persona',
      upTo: 'hasta',
      pax: 'pax',
      pageTitle: 'Tours y Aventuras',
      pageSubtitle: 'Vive Costa Rica con Travel Guide Costa Rica - Transporte, aventuras en ATV, canopy, cabalgatas y mucho más. Todos los tours incluyen transporte desde Los Sueños.',
      transportIncluded: 'Transporte desde Los Sueños incluido',
      fruitsHydration: 'Frutas frescas e hidratación',
      lunchOption: 'Opción de almuerzo +$10 (Gratis en Combos de Día Completo)',
      noToursFound: 'No se encontraron tours',
      tryDifferent: 'Intenta seleccionar una categoría diferente',
      perPersonLabel: '/ persona',
      per2People: '/ 2 personas',
      perUpTo5Pax: '/ hasta 5 pax',
      transportPlusTours: 'transporte (5 pax) + tours',
      transportPlusTour: 'transporte (5 pax) + tour',
      lunchIncluded: 'ALMUERZO INCLUIDO',
      onePerson: '1 persona',
      twoPeople: '2 personas',
      upToLabel: 'Hasta',
      requirementsTitle: 'Requisitos y Políticas',
      atvTitle: 'ATV y Buggy',
      atvReq1: 'Licencia de conducir válida (A1 o B1) requerida',
      atvReq2: 'Peso máx: 120kg (sencillo), 200kg (buggy)',
      atvReq3: 'Se requiere depósito de seguridad (reembolsable)',
      atvReq4: 'Cancelación 24 horas: reembolso 100%',
      ziplineTitle: 'Canopy',
      ziplineReq1: 'Peso máx: 120kg (265 lbs)',
      ziplineReq2: 'Cintura máx: 99cm (39 in)',
      ziplineReq3: 'Niños desde 4 años bienvenidos',
      ziplineReq4: 'Cancelaciones: Solo reprogramar',
      horsebackTitle: 'Cabalgata',
      horsebackReq1: 'Peso máx: 100kg (220 lbs)',
      horsebackReq2: 'Apto para principiantes',
      horsebackReq3: 'Caballos mansos y bien entrenados',
      horsebackReq4: 'Cancelación 24 horas: reembolso 100%',
      generalTitle: 'Información General',
      genReq1: 'Transporte desde Los Sueños incluido',
      genReq2: 'Guías certificados en todos los tours',
      genReq3: 'Agregar almuerzo: +$10 por persona',
      genReq4: 'Combos de Día Completo incluyen almuerzo GRATIS',
      customCtaTitle: '¿Necesitas un Paquete Personalizado?',
      customCtaSubtitle: '¿No encuentras lo que buscas? Contáctanos para un paquete de tour personalizado a tu medida.',
      customCtaButton: 'Contáctanos por WhatsApp'
    },
    // Booking
    booking: {
      title: 'Reserva Tu Experiencia',
      backToTours: 'Volver a Tours',
      step1: 'Datos',
      step2: 'Pago',
      step3: 'Confirmación',
      bookingDetails: 'Detalles de la Reserva',
      fullName: 'Nombre Completo',
      fullNamePlaceholder: 'Juan Pérez',
      email: 'Correo Electrónico',
      emailPlaceholder: 'juan@ejemplo.com',
      phone: 'Teléfono',
      phonePlaceholder: '+506 1234 5678',
      date: 'Fecha del Viaje',
      passengers: 'Número de Pasajeros',
      passenger: 'pasajero',
      passengersPlural: 'pasajeros',
      notes: 'Solicitudes Especiales (Opcional)',
      notesPlaceholder: 'Cualquier solicitud especial... (ej: número de vuelo, recogida en hotel)',
      continuePayment: 'Continuar al Pago',
      processing: 'Procesando...',
      basePrice: 'Precio base (hasta 5 pax)',
      extraPax: 'Pax extra',
      addOns: 'Extras',
      subtotal: 'Subtotal',
      vat: 'IVA (13%)',
      total: 'Total',
      vatIncluded: 'IVA incluido',
      optionalAddOns: 'Extras Opcionales',
      howMany: '¿Cuántos?',
      included: 'incluidos',
      extraPerPax: 'extra/pasajero',
      flatRate: 'Tarifa fija para 1-5 pasajeros',
      upToIncluded: 'Hasta 5 pasajeros incluidos.',
      perExtra: '/pasajero extra',
      pricePerPerson: 'Precio por persona',
      perPersonNote: 'por persona',
      payWithStripe: 'Pagar con Tarjeta',
      stripeDesc: 'Visa, Mastercard, American Express',
      payWithPaypal: 'Pagar con PayPal',
      paypalDesc: 'Pago directo vía PayPal.me',
      perPerson: '/persona',
      securePayment: 'Pago Seguro:',
      secureDesc: 'Tu información de pago está encriptada y segura. Nunca almacenamos los datos de tu tarjeta.',
      back: 'Atrás',
      backToDetails: 'Volver a Detalles',
      bookingCreated: '¡Reserva creada! Por favor completa el pago.',
      bookingFailed: 'Error al crear la reserva. Intenta de nuevo.',
      tourNotFound: 'Tour no encontrado',
      paymentFailed: 'El pago falló. Por favor intenta de nuevo.',
      selectPaymentMethod: 'Selecciona Método de Pago',
      paymentSubtitle: 'Elige tu método de pago preferido para completar la reserva.',
      max: 'Máx',
      paxRange: '1-5 pax',
      paxLabel: 'Pasajeros',
      extraPaxFee: '/persona',
      nationalParkFees: 'Entradas al Parque Nacional',
      bookOnline: 'Reservar en línea',
      addOnsTotal: 'Total de extras:',
      paypalRedirect: 'Redirigiendo a PayPal. Después del pago, envía un correo de confirmación.'
    },
    // Reviews
    reviews: {
      title: 'Lo Que Dicen Nuestros Clientes',
      subtitle: 'Lee las reseñas de viajeros que experimentaron nuestros servicios',
      viewAll: 'Ver Todas las Reseñas en TripAdvisor',
      rating: 'Calificación',
      reviews: 'reseñas'
    },
    // About
    about: {
      title: 'Sobre Travel Guide Costa Rica',
      subtitle: '¿Por Qué Elegirnos?',
      description: 'Con más de 20 años de experiencia, brindamos servicios de transporte y tours seguros, confiables y memorables en todo Costa Rica.',
      experience: 'Años de Experiencia',
      customers: 'Clientes Felices',
      toursCompleted: 'Tours Completados',
      rating: 'Calificación',
      whyUs1Title: 'Conductores Profesionales',
      whyUs1Desc: 'Conductores experimentados y bilingües que conocen cada ruta',
      whyUs2Title: 'Vehículos Premium',
      whyUs2Desc: 'Vehículos modernos con aire acondicionado para tu comodidad',
      whyUs3Title: 'Mejores Precios',
      whyUs3Desc: 'Tarifas competitivas sin cargos ocultos',
      whyUs4Title: 'Soporte 24/7',
      whyUs4Desc: 'Siempre disponibles para asistirte'
    },
    // Contact
    contact: {
      title: 'Contáctanos',
      subtitle: 'Ponte en contacto con nuestro equipo',
      whatsapp: 'WhatsApp',
      email: 'Correo',
      phone: 'Teléfono',
      location: 'Ubicación',
      sendMessage: 'Enviar Mensaje',
      sending: 'Enviando...',
      name: 'Tu Nombre',
      yourEmail: 'Tu Correo',
      yourPhone: 'Tu Teléfono',
      message: 'Mensaje',
      messagePlaceholder: '¿Cómo podemos ayudarte?',
      successMessage: '¡Mensaje enviado! Te contactaremos pronto.',
      errorMessage: 'Error al enviar. Por favor usa WhatsApp.',
      quickContact: 'Contacto Rápido',
      responseTime: 'Normalmente respondemos en 1 hora'
    },
    // Footer
    footer: {
      description: 'Tu socio de confianza en transporte y tours en Costa Rica por más de 20 años.',
      quickLinks: 'Enlaces Rápidos',
      contactUs: 'Contáctanos',
      followUs: 'Síguenos',
      services: 'Servicios',
      legal: 'Legal',
      privacy: 'Política de Privacidad',
      terms: 'Términos de Servicio',
      cancellation: 'Política de Cancelación',
      environmental: 'Política Ambiental',
      safety: 'Información de Seguridad',
      community: 'Apoyo a Comunidades Locales',
      allRights: 'Todos los derechos reservados.',
      airportTransfers: 'Traslados al Aeropuerto',
      privateTours: 'Tours Privados',
      adventureTours: 'Tours de Aventura',
      home: 'Inicio',
      toursTransfers: 'Tours y Traslados',
      aboutUs: 'Nosotros',
      reviews: 'Reseñas',
      contact: 'Contacto',
      excellence: 'Más de 20 años de excelencia en el turismo costarricense',
      location: 'San Pedro de Poás, Costa Rica'
    },
    // Success Page
    success: {
      title: '¡Reserva Confirmada!',
      subtitle: 'Gracias por reservar con Travel Guide Costa Rica. ¡No vemos la hora de mostrarte la belleza de Costa Rica!',
      bookingReference: 'Referencia de Reserva',
      confirmed: 'Confirmada',
      bookedOn: 'Reservado el:',
      contactInformation: 'Información de Contacto',
      totalPaid: 'Total Pagado',
      whatNext: '¿Qué Sigue?',
      step1: 'Recibirás un correo de confirmación con todos los detalles.',
      step2: 'Nuestro equipo te contactará 24 horas antes de tu fecha programada.',
      step3: 'Para cualquier pregunta, contáctanos por WhatsApp al +506 8817-3167.',
      checkEmail: 'Revisa Tu Correo',
      emailFrom: 'Tu confirmación será enviada desde',
      checkSpam: 'Si no la ves en tu bandeja de entrada, revisa tu carpeta de',
      spamFolder: 'Spam',
      or: 'o',
      junkFolder: 'Correo no deseado',
      markNotSpam: 'y márcanos como "No es spam" para recibir comunicaciones futuras.',
      browseMore: 'Ver Más Tours',
      contactWhatsapp: 'Contactar por WhatsApp',
      verifying: 'Verificando tu pago...',
      pleaseWait: 'Por favor espera mientras confirmamos tu reserva.',
      paymentIssue: 'Problema con el Pago',
      browseTours: 'Ver Tours',
      contactSupport: 'Contactar Soporte',
      missingInfo: 'Falta información de pago',
      timedOut: 'La verificación del pago expiró. Contacta a soporte.',
      sessionExpired: 'La sesión de pago expiró. Intenta de nuevo.',
      failedVerify: 'No se pudo verificar el pago. Contacta a soporte.',
      passenger: 'pasajero',
      passengersPlural: 'pasajeros'
    },
    // Cancellation Policy
    cancellation: {
      title: 'Política de Cancelación',
      subtitle: 'Por favor lee nuestra política de cancelación cuidadosamente antes de hacer una reserva.',
      importantNotice: 'Aviso Importante',
      importantNoticeText: 'Al completar tu reserva, reconoces que has leído, entendido y aceptas nuestra política de cancelación y los requisitos de información de recogida.',
      pickupTitle: 'Requisitos de Información de Recogida y Destino',
      pickupDesc: 'Para garantizar un servicio fluido y puntual, por favor proporciona información precisa y completa al hacer tu reserva.',
      forTransfers: 'Para Traslados al Aeropuerto',
      transfersDesc: 'Traslado al Aeropuerto, Transporte de Lujo y Traslado a Arenal',
      coverageArea: 'Área de Cobertura del Servicio',
      airportZone: 'Zona del Aeropuerto:',
      airportZoneDesc: 'Dentro de 5 millas del Aeropuerto Internacional Juan Santamaría (SJO)',
      losSuenosResort: 'Resort Los Sueños:',
      losSuenosDesc: 'Cualquier hotel, condominio o propiedad privada dentro de Los Sueños Marriott Resort & Marina',
      arriving: 'Llegando a Costa Rica',
      arrivingSubtitle: 'Aeropuerto SJO (dentro de 5 millas) → Resort Los Sueños',
      arrivalFlight: 'Número de vuelo de llegada',
      arrivalDate: 'Fecha y hora de llegada',
      airline: 'Nombre de aerolínea',
      destAddress: 'Dirección/hotel de destino exacto',
      numPassengers: 'Número de pasajeros',
      contactPhone: 'Teléfono de contacto',
      departing: 'Saliendo de Costa Rica',
      departingSubtitle: 'Resort Los Sueños → Aeropuerto SJO (dentro de 5 millas)',
      departureFlight: 'Número de vuelo de salida',
      departureDate: 'Fecha y hora de salida',
      pickupAddress: 'Dirección/hotel de recogida exacto',
      forTours: 'Para Tours y Aventuras',
      toursDesc: 'ATV, Canopy, Cabalgata, Combos y Otros Tours',
      requiredPickup: 'Información de Recogida Requerida',
      pickupInfoDesc: 'Por favor proporciona tu ubicación exacta de recogida para que nuestro equipo llegue a tiempo:',
      hotelName: 'Nombre del hotel o dirección de la propiedad',
      pickupTime: 'Hora de Recogida',
      pickupTimeDesc: 'Nuestro equipo confirmará tu hora exacta de recogida según el horario del tour. La recogida es típicamente 30 minutos antes del inicio del tour.',
      disclaimer: 'Aviso Importante',
      disclaimerText: 'Travel Guide Costa Rica no es responsable por problemas, retrasos o servicios perdidos resultantes de información incorrecta, incompleta o poco clara proporcionada por el cliente. Esto incluye pero no se limita a:',
      disclaimer1: 'Direcciones de recogida o destino incorrectas',
      disclaimer2: 'Números o horarios de vuelo incorrectos',
      disclaimer3: 'No proporcionar información de contacto',
      disclaimer4: 'Mala comunicación sobre ubicaciones de recogida',
      disclaimerEnd: 'Por favor verifica todos los detalles antes de confirmar tu reserva.',
      customerCancel: 'Cancelación por el Cliente',
      lessThan24h: 'Menos de 24 horas antes del servicio',
      lessThan24hDesc: 'Sin reembolso. Las cancelaciones hechas menos de 24 horas antes del tour o traslado no son elegibles para reembolso.',
      moreThan24h: 'Más de 24 horas antes del servicio',
      moreThan24hDesc: 'Reembolso completo disponible. Las cancelaciones hechas más de 24 horas en adelanto son elegibles para reembolso completo.',
      noShow: 'Política de No-Presentación',
      noShowTitle: 'No presentarse en la recogida programada',
      noShowDesc: 'Si no te presentas en el lugar de recogida designado a la hora programada sin previo aviso, no se proporcionará reembolso y se cobrará el monto completo.',
      weather: 'Cancelaciones por Clima',
      weatherDesc: 'Tu seguridad es nuestra prioridad. En casos de condiciones climáticas severas que hagan inseguro proceder con el servicio:',
      fullRefund100: 'Reembolso Completo 100%',
      fullRefund100Desc: 'Si tu tour o traslado es cancelado debido a malas condiciones climáticas (lluvia fuerte, tormentas, inundaciones u otras condiciones inseguras), recibirás un reembolso completo del 100% de tu pago.',
      weatherNote: '* Las cancelaciones por clima son determinadas por Travel Guide Costa Rica con base en evaluaciones de seguridad. También puedes elegir reprogramar sin costo adicional.',
      companyCancel: 'Cancelación por Travel Guide Costa Rica',
      companyCancelDesc: 'En el raro caso de que tengamos que cancelar tu servicio debido a circunstancias imprevistas (clima severo, desastres naturales, emergencias vehiculares u otros factores fuera de nuestro control), se te ofrecerá:',
      fullRefund: 'Reembolso Completo',
      fullRefundDesc: '100% de tu pago devuelto dentro de 5-7 días hábiles',
      rescheduling: 'Reprogramación',
      reschedulingDesc: 'Reprograma tu servicio sin costo adicional',
      howToCancel: 'Cómo Solicitar una Cancelación',
      howToCancelDesc: 'Todas las solicitudes de cancelación deben enviarse por correo a:',
      includeBooking: 'Por favor incluye tu número de confirmación de reserva y el motivo de la cancelación.',
      refundTime: 'Tiempo de Procesamiento del Reembolso',
      businessDays: '5-7 Días Hábiles',
      businessDaysDesc: 'Los reembolsos aprobados se procesarán dentro de 5-7 días hábiles. El reembolso se acreditará al método de pago original usado durante la reserva.',
      questions: '¿Tienes Preguntas?',
      questionsDesc: 'Si tienes alguna pregunta sobre nuestra política de cancelación, no dudes en contactarnos.',
      emailUs: 'Envíanos un Correo',
      whatsapp: 'WhatsApp',
      lastUpdated: 'Última actualización: Marzo 2026'
    },
    // Blog
    blog: {
      title: 'Blog de Viajes',
      subtitle: 'Consejos, guías y novedades sobre transporte y aventuras en Costa Rica',
      loading: 'Cargando artículos del blog...'
    },
    // Apoyo a Comunidades Locales (página dedicada)
    community: {
      title: 'Apoyo a Comunidades Locales',
      subtitle: 'Travel Guide Costa Rica cree en un turismo que fortalece a las personas y los lugares donde opera.',
      p1: 'Travel Guide Costa Rica promueve el turismo responsable apoyando negocios, guías y proveedores locales de las comunidades donde opera.',
      p2: 'Asimismo, se incentiva a los viajeros a respetar las costumbres locales, consumir productos nacionales y contribuir positivamente al desarrollo sostenible de las comunidades visitadas.',
      p3: 'Nuestra empresa fomenta prácticas de educación ambiental y conciencia ecológica durante los servicios turísticos y de transporte.',
      closingTitle: 'Viaja con Propósito',
      closingText: 'Cada tour que reservas ayuda a fortalecer a las familias locales y a proteger la herencia de Costa Rica. Gracias por ser parte de este viaje.',
      lastUpdated: 'Última actualización: Mayo 2026'
    },
    // Safety Information (cumplimiento ICT)
    safety: {
      title: 'Información de Seguridad',
      subtitle: 'Tu seguridad es nuestra prioridad. Por favor lee estas recomendaciones antes y durante los tours.',
      intro: 'Travel Guide Costa Rica está comprometido con brindar experiencias seguras, confiables y agradables. Esta página detalla las pautas de seguridad esenciales para todos los viajeros — requeridas para el cumplimiento con el Instituto Costarricense de Turismo (ICT).',
      generalTitle: 'Seguridad General del Turista',
      generalIntro: 'Para garantizar una experiencia segura en Costa Rica:',
      gen1: 'Lleva siempre una copia de tu pasaporte o documento oficial.',
      gen2: 'Informa a una persona de confianza tu itinerario diario.',
      gen3: 'Guarda objetos de valor (pasaporte, electrónicos, joyas) en la caja fuerte del hotel cuando sea posible.',
      gen4: 'Usa solo servicios de transporte oficiales y autorizados como Travel Guide Costa Rica.',
      gen5: 'Confía en tu instinto — si un lugar o situación se siente inseguro, retírate inmediatamente.',
      seatbeltsTitle: 'Cinturones de Seguridad y Seguridad Vehicular',
      seatbeltsHighlight: '⚠️ El uso del cinturón de seguridad es OBLIGATORIO en Costa Rica — para TODOS los pasajeros en TODOS los asientos.',
      belt1: 'Abróchate el cinturón apenas te sientes y mantenlo abrochado hasta que el vehículo se detenga.',
      belt2: 'Los niños menores de 12 años deben viajar en el asiento trasero con sistema de retención adecuado.',
      belt3: 'Niños menores de 4 años o de menos de 1.45 m deben usar silla de seguridad infantil.',
      belt4: 'No distraigas al conductor durante el viaje; cualquier solicitud puedes hacerla con calma.',
      belt5: 'Los vehículos de Travel Guide son inspeccionados regularmente y cumplen con los estándares técnicos RITEVE.',
      recommendationsTitle: 'Recomendaciones',
      beforeTitle: 'Antes del Tour',
      before1: 'Hidrátate, duerme bien y come ligero antes de tours de aventura.',
      before2: 'Usa ropa cómoda y zapatos cerrados para actividades al aire libre.',
      before3: 'Lleva bloqueador solar, lentes de sol, sombrero, repelente y botella reutilizable de agua.',
      before4: 'Informa a nuestro equipo sobre cualquier condición médica, alergia o medicamento que tomes.',
      duringTitle: 'Durante el Tour',
      during1: 'Sigue siempre las instrucciones de tu guía y conductor.',
      during2: 'Permanece con tu grupo; no te alejes de los senderos autorizados.',
      during3: 'Mantén efectivo, documentos y electrónicos en un bolsillo o bolso seguro.',
      during4: 'Comunica cualquier molestia o problema de salud al guía de inmediato.',
      during5: 'No consumas alcohol ni sustancias antes o durante tours activos.',
      healthTitle: 'Recomendaciones de Salud',
      health1: 'El clima tropical de Costa Rica puede causar agotamiento por calor — bebe agua frecuentemente.',
      health2: 'Usa bloqueador biodegradable para proteger tu piel y el medio ambiente.',
      health3: 'Si sientes mareos, náuseas o fatiga inusual, detén la actividad e informa a tu guía.',
      health4: 'Se recomienda altamente contar con un seguro de viaje para visitantes internacionales.',
      conductTitle: 'Código de Conducta',
      conductIntro: 'Costa Rica es conocida por su "Pura Vida" — ayúdanos a preservar ese espíritu:',
      doTitle: 'Por favor SÍ',
      do1: 'Respeta a las comunidades locales, costumbres y pueblos indígenas.',
      do2: 'Sé paciente y amable — "Pura Vida" es un estilo de vida aquí.',
      do3: 'Apoya negocios locales, artesanos y emprendimientos familiares.',
      do4: 'Reporta inmediatamente cualquier situación insegura al guía o autoridades.',
      dontTitle: 'Por favor NO',
      dont1: 'No alimentes, toques ni persigas la fauna silvestre.',
      dont2: 'No recolectes plantas, conchas, piedras ni elementos naturales.',
      dont3: 'No participes en actividades ilegales ni consumas sustancias ilegales.',
      dont4: 'No participes en explotación infantil con fines turísticos (delito en Costa Rica — Ley 7899).',
      dont5: 'No ingreses a propiedad privada ni áreas restringidas sin permiso.',
      emergencyTitle: 'Emergencias',
      emergencyNumber: 'Número Nacional de Emergencias',
      emergencyNumberHint: 'Gratuito 24/7 desde cualquier teléfono en Costa Rica',
      duringEmergencyTitle: 'En Caso de Emergencia',
      emg1: 'Mantén la calma. Llama al 911 inmediatamente e indica tu ubicación con claridad.',
      emg2: 'Si estás herido, no te muevas innecesariamente — espera ayuda profesional.',
      emg3: 'Sigue las instrucciones de evacuación o primeros auxilios del guía.',
      emg4: 'Notifica a la embajada de tu país si eres visitante extranjero.',
      emg5: 'Travel Guide te ayudará con logística, transporte al centro médico más cercano y comunicación.',
      numbersTitle: 'Números Importantes',
      policeLabel: 'Emergencias (Policía, Bomberos, Médico)',
      trafficLabel: 'Policía de Tránsito',
      redCrossLabel: 'Cruz Roja (Ambulancia)',
      firefightersLabel: 'Bomberos',
      touristPoliceLabel: 'Policía Turística',
      tgcrLabel: 'Travel Guide CR — 24/7',
      insuranceTitle: 'Seguros y Cumplimiento Vehicular',
      insuranceIntro: 'Todos los vehículos de Travel Guide Costa Rica operan con:',
      ins1: 'Seguro obligatorio (SOA) y cobertura adicional para pasajeros.',
      ins2: 'Revisión técnica certificada por RITEVE (estándares de seguridad vehicular).',
      ins3: 'Conductores capacitados con credenciales comerciales vigentes (CTP).',
      commitmentTitle: 'Nuestro Compromiso de Seguridad',
      commitmentText: 'Travel Guide Costa Rica opera en cumplimiento con las regulaciones aplicables del sector turístico costarricense y mantiene el compromiso de fortalecer continuamente sus estándares de seguridad, calidad y sostenibilidad.',
      lastUpdated: 'Última actualización: Mayo 2026'
    },
    // Environmental Policy
    environmental: {
      title: 'Política Ambiental para Viajeros',
      subtitle: 'Travel Guide Costa Rica - Turismo sostenible y responsable',
      intro1: 'En Travel Guide Costa Rica creemos que viajar por Costa Rica debe ser una experiencia inolvidable y, al mismo tiempo, responsable con el medio ambiente.',
      intro2: 'Como país pionero en conservación ambiental y turismo sostenible, Costa Rica protege activamente sus bosques, playas, ríos, fauna silvestre y parques nacionales. Por eso, invitamos a todos nuestros viajeros a adoptar prácticas responsables durante los tours y servicios de transporte.',
      commitmentTitle: 'Nuestro Compromiso Ambiental',
      commitmentIntro: 'Travel Guide Costa Rica se compromete a:',
      commitment1: 'Promover un turismo sostenible y responsable.',
      commitment2: 'Reducir el impacto ambiental de nuestras operaciones.',
      commitment3: 'Fomentar buenas prácticas ambientales entre viajeros y colaboradores.',
      commitment4: 'Respetar las leyes ambientales y regulaciones de Costa Rica.',
      commitment5: 'Proteger la biodiversidad y los recursos naturales del país.',
      wasteTitle: 'Política de Manejo de Desechos en Transporte',
      wasteIntro: 'Para mantener limpias las carreteras, comunidades y áreas naturales de Costa Rica:',
      wasteUnits: 'En todas nuestras unidades de transporte:',
      waste1: 'Cada vehículo cuenta con basurero interno para disposición de residuos.',
      waste2: 'Se solicita a los pasajeros no lanzar basura por ventanas o puertas.',
      waste3: 'Los residuos serán recolectados y desechados adecuadamente al finalizar cada servicio.',
      waste4: 'Promovemos la reducción del uso de plásticos de un solo uso.',
      waste5: 'Recomendamos utilizar botellas reutilizables y artículos ecoamigables.',
      wasteSeparation: 'Separación de residuos',
      separationIntro: 'Cuando sea posible, fomentamos la separación de:',
      plastic: 'Plástico',
      aluminum: 'Aluminio',
      paper: 'Papel',
      organic: 'Orgánico',
      behaviorTitle: 'Comportamiento Responsable en la Naturaleza',
      behaviorIntro: 'Costa Rica alberga cerca del 6% de la biodiversidad mundial. Ayúdanos a protegerla siguiendo estas recomendaciones:',
      wildlifeTitle: 'Respeto a la fauna silvestre',
      wildlife1: 'No alimentar animales silvestres.',
      wildlife2: 'No tocar ni perseguir animales.',
      wildlife3: 'Mantener distancia segura de la fauna.',
      ecoTitle: 'Protección de ecosistemas',
      eco1: 'Permanecer en senderos autorizados.',
      eco2: 'No extraer plantas, piedras, conchas o elementos naturales.',
      eco3: 'No dañar arrecifes, manglares o bosques.',
      wasteRespTitle: 'Manejo responsable de residuos',
      wasteResp1: 'Llevar siempre su basura hasta encontrar un recipiente adecuado.',
      wasteResp2: 'Evitar dejar residuos en playas, ríos o parques nacionales.',
      pollutionTitle: 'Reducción de contaminación',
      pollution1: 'Evitar el uso excesivo de plásticos desechables.',
      pollution2: 'Minimizar ruido en áreas naturales.',
      pollution3: 'Utilizar bloqueadores y productos biodegradables cuando sea posible.',
      waterEnergyTitle: 'Uso Responsable del Agua y Energía',
      waterEnergyIntro: 'Invitamos a nuestros viajeros a:',
      waterEnergy1: 'Utilizar el agua de forma consciente.',
      waterEnergy2: 'Apagar luces y aire acondicionado cuando no sean necesarios.',
      waterEnergy3: 'Apoyar negocios locales comprometidos con sostenibilidad.',
      complianceTitle: 'Cumplimiento de Normativas Ambientales de Costa Rica',
      complianceIntro: 'Esta política se inspira en principios promovidos por instituciones y programas ambientales de Costa Rica, incluyendo:',
      compliance1: 'Sistema Nacional de Áreas de Conservación (SINAC)',
      compliance2: 'Instituto Costarricense de Turismo (ICT)',
      compliance3: 'Programa de Sostenibilidad Turística',
      compliance4: 'Legislación ambiental costarricense vigente',
      educationTitle: 'Educación y Conciencia Ambiental',
      educationIntro: 'Nuestro objetivo es que cada visitante:',
      education1: 'Disfrute de Costa Rica,',
      education2: 'Conozca su riqueza natural,',
      education3: 'Y contribuya activamente a su conservación para futuras generaciones.',
      communityTitle: 'Apoyo a Comunidades Locales',
      community1: 'Travel Guide Costa Rica promueve el turismo responsable apoyando negocios, guías y proveedores locales de las comunidades donde opera.',
      community2: 'Asimismo, se incentiva a los viajeros a respetar las costumbres locales, consumir productos nacionales y contribuir positivamente al desarrollo sostenible de las comunidades visitadas.',
      community3: 'Nuestra empresa fomenta prácticas de educación ambiental y conciencia ecológica durante los servicios turísticos y de transporte.',
      invitationTitle: 'Invitación al Viajero',
      invitationQuote: 'Viajar responsablemente significa dejar únicamente huellas y llevarse únicamente recuerdos.',
      invitationThanks: 'Gracias por ayudarnos a proteger la naturaleza de Costa Rica.',
      lastUpdated: 'Última actualización: Mayo 2026'
    },
    // Survey
    survey: {
      title: '¿Cómo fue tu experiencia?',
      subtitle: 'Tu opinión nos ayuda a mejorar. Toma 2 minutos.',
      hello: 'Hola',
      thanksFor: 'Gracias por elegir Travel Guide Costa Rica para tu',
      overall: 'En general, ¿cómo calificarías tu experiencia?',
      tapToRate: 'Toca las estrellas para calificar',
      categoriesTitle: 'Califica cada aspecto (opcional)',
      driver: 'Conductor',
      vehicle: 'Vehículo',
      punctuality: 'Puntualidad',
      tour: 'Tour / Servicio',
      npsQuestion: '¿Qué tan probable es que nos recomiendes a un amigo?',
      npsHint: '0 = Nada probable · 10 = Muy probable',
      recommendQuestion: '¿Volverías a reservar con nosotros?',
      yes: 'Sí',
      no: 'No',
      commentLabel: '¿Algún comentario o sugerencia? (opcional)',
      commentPlaceholder: 'Cuéntanos qué hicimos bien o cómo podemos mejorar...',
      submitBtn: 'Enviar Comentarios',
      submitting: 'Enviando...',
      ratingRequired: 'Por favor selecciona una calificación',
      thanks5Title: '🎉 ¡Muchísimas gracias!',
      thanks5Subtitle: '¡Nos alegra que lo disfrutaras! ¿Te importaría compartir tu experiencia públicamente? Realmente ayuda a pequeños negocios como el nuestro.',
      shareTripadvisor: 'Compartir en TripAdvisor',
      shareGoogle: 'Compartir en Google',
      noThanks: 'Quizás después',
      thanksLowTitle: 'Gracias por tu opinión sincera',
      thanksLowSubtitle: 'Sentimos que tu experiencia no fuera perfecta. Nuestro equipo te contactará pronto para mejorarlo.',
      backHome: 'Volver al inicio',
      alreadySubmittedTitle: 'Encuesta ya enviada',
      alreadySubmittedSubtitle: '¡Gracias! Ya recibimos tu opinión para esta reserva.',
      invalidTitle: 'Enlace inválido o expirado',
      invalidSubtitle: 'Por favor usa el enlace de tu correo. Si sigues teniendo problemas, contáctanos por WhatsApp.',
      loading: 'Cargando...',
      q1: '¿Cómo calificarías la puntualidad del servicio?',
      q2: '¿Cómo calificarías la atención y amabilidad del conductor o guía?',
      q3: '¿Cómo calificarías la limpieza y comodidad del vehículo o servicio recibido?',
      q4: '¿Te sentiste seguro(a) durante el traslado o tour?',
      q5: '¿Recomendarías Travel Guide Costa Rica a otros viajeros?',
      answerRequired: 'Por favor responde todas las preguntas antes de enviar.',
      opt: {
        excelente: 'Excelente', muy_buena: 'Muy buena', buena: 'Buena', regular: 'Regular', deficiente: 'Deficiente',
        si_completamente: 'Sí, completamente', si_mayoria: 'Sí, en su mayoría', parcialmente: 'Parcialmente', no: 'No',
        si_definitivamente: 'Sí, definitivamente', probablemente_si: 'Probablemente sí', no_seguro: 'No estoy seguro(a)', probablemente_no: 'Probablemente no'
      }
    },
    // Common
    common: {
      loading: 'Cargando...',
      error: 'Ocurrió un error',
      success: '¡Éxito!',
      close: 'Cerrar',
      back: 'Atrás',
      next: 'Siguiente',
      submit: 'Enviar',
      cancel: 'Cancelar',
      learnMore: 'Saber Más',
      seeAll: 'Ver Todo'
    }
  }
};

export default translations;
